import { helper } from '@ember/component/helper';

import { A } from '@ember/array';

export default helper(function metaMapHelper([ arrOrLen ], meta) {
  const len = (arrOrLen && typeof arrOrLen === 'object' ? arrOrLen.length : arrOrLen) || 0;
  const result = A([]);
  for (let i = 0; i < len; ++i) {
    result.pushObject(Object.assign({}, meta));
  }
  return result;
});
